import { Relationships } from '@leverege/molten/data-source';
import { Types } from "../constants/index.js";
import FirmwareApplicationGroupDelegate from "../delegates/firmwareApplication/FirmwareApplicationGroupDelegate.js";
import FirmwareApplicationItemDelegate from "../delegates/firmwareApplication/FirmwareApplicationItemDelegate.js";
export default class FirmwareApplicationDataSource {
  dataSource() {
    return Types.firmwareApplication;
  }
  getData(objRef) {
    return this.getActions(objRef)?.getItem();
  }
  getActions(objRef, ...rest) {
    const relationship = Relationships.getAll().find(rel => rel.refPath === objRef?.ref);
    if (!relationship) {
      return null;
    }
    if (objRef?.id) {
      return new FirmwareApplicationItemDelegate({
        item: objRef,
        id: objRef?.id,
        relationship
      });
    }
    return new FirmwareApplicationGroupDelegate({
      relationship
    });
  }
}